module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_mobile@2x-6d7fed012f5dc93531021e79c9914218.png";